import { render, staticRenderFns } from "./Trained.vue?vue&type=template&id=f8ad2876&scoped=true&"
import script from "./Trained.vue?vue&type=script&lang=ts&"
export * from "./Trained.vue?vue&type=script&lang=ts&"
import style0 from "./Trained.vue?vue&type=style&index=0&id=f8ad2876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ad2876",
  null
  
)

component.options.__file = "Trained.vue"
export default component.exports